import type { InitElementsParams, SummaryItem, ElementItem, RelatedIpcItem } from '../type/ai-search.type';

export const AISearchRepository = Symbol('AISearchRepository');

export interface AISearchRepositorySummaryData {
    summary: SummaryItem[],
    topic: InitElementsParams['topic'],
    relatedIpc: InitElementsParams['relatedIpc'],
}

export interface AISearchRepositoryElementsParams {
    area: InitElementsParams['topic'],
    topics: InitElementsParams['summary'],
}

export interface AISearchRepositoryElementsData {
    topic: {
        elements: ElementItem[],
    },
    element: {
        elements: ElementItem[],
    },
}

export interface AISearchRepository {
    checkSensitiveWord: (value: string) => Promise<boolean>;
    getQueryCount: (q: string) => Promise<number>;
    setTechQuery: (value: { queryBody: string, comment?: string }[]) => Promise<string>;
    transferQuery: (value: {
        query: string;
        search_from: string;
    }) => Promise<{
        q: string;
        type: string;
    }>;
    getSummary: (taskId: string, desc: string) => Promise<AISearchRepositorySummaryData>;
    getElements: (taskId: string, params: AISearchRepositoryElementsParams) => Promise<AISearchRepositoryElementsData>;
    getSemantic: (value: string[]) => Promise<{
        [key: string]: string
    }>;
    getRelatedIpc: (value: string, type: string) => Promise<RelatedIpcItem[]>;
}
